import { Button, Card, CustomTextField } from 'components';
import styles from './Login.module.css';
import { useForm, SubmitHandler } from "react-hook-form";
import { Logo } from 'assets';
import { LoginInputs } from 'types/formTypes';
import { Box, Divider } from '@mui/material';
import { apiGetUserDetails, apiLogin } from 'services';
import { setToken, setUser } from 'store/user/userSlice';
import { useAppDispatch } from 'store/hooks';
import { useNavigate } from 'react-router-dom';
import { env } from 'env';

const Login = () => {
  const { handleSubmit, control, formState: { errors }, setError } = useForm<LoginInputs>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate()

  const onSubmit: SubmitHandler<LoginInputs> = (data) => {
    const { identifier, password } = data;

    apiLogin({ identifier, password })
      .then(async res => {
        dispatch(setToken(res.jwt))
        const userDetails = await apiGetUserDetails();
        if (userDetails?.userImage && typeof userDetails.userImage !== 'string' && 'formats' in userDetails.userImage) {
          userDetails.userImage = `${env.BASE_URL}${userDetails.userImage.url}`;
        }

        dispatch(setUser(userDetails))
      })
      .catch(err => {
        setError("identifier", { message: "" });
        setError("password", { message: "הפרטים שסיפקת אינם תואמים את הרשומות שלנו. אנא נסה שוב." });
        console.log(err)
      });
  };




  return (
    <div className={styles.container}>
      <Card>
        <Logo />
        <p className={styles.title}>כניסה למערכת</p>
        <form style={{ width: '80%' }} onSubmit={handleSubmit(onSubmit)}>
          <Box justifyContent="space-between" display="flex" alignItems="center" marginBottom={2}>
            <p className={styles.label}>כתובת דוא״ל</p>
            <Box sx={{ flexGrow: 1 }}>
              <CustomTextField
                name="identifier"
                type="email"
                fullWidth
                control={control}
                rules={{
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: 'אנא הכנס כתובת דוא״ל תקינה'
                  },
                  required: true
                }}
                placeholder="@"
                errorMessage={errors.identifier?.message}
              />
            </Box>
          </Box>

          <Box display="flex" alignItems="center" marginBottom={2} width="100%">
            <p className={styles.label}>סיסמה</p>
            <Box sx={{ flexGrow: 1 }}>
              <CustomTextField
                name="password"
                type="password"
                fullWidth
                control={control}
                rules={{ required: 'אנא הכנס סיסמה תקינה' }}
                errorMessage={errors.password?.message}
              />
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" alignItems="center" marginTop={3}>
            <Button type="submit" text="כניסה למערכת" />
          </Box>
          <div className='d-flex justify-content-between'>
            <button onClick={() => navigate('/forgot-password')} className='mt-2'>שכחתי סיסמה</button>
            <button onClick={() => navigate('/register')} className='mt-2'>הרשמה</button>
          </div>
        </form>
        {errors.identifier && <p className={styles.error}>{errors.identifier?.message}</p>}
        {errors.password && <p className={styles.error}>{errors.password?.message}</p>}

        <Divider />
      </Card>
    </div>
  );
};

export default Login;
